import Image from 'next/image'
import classNames from 'classnames'
import { PrismicResultsItem } from '../../prismic-types-d'

interface MResultContentItemProps extends PrismicResultsItem {
  isOdd: boolean
}

export const MResultContentItem = ({
  link_heading: linkHeading,
  link_subheading: linkSubHeading,
  link_url: linkUrl,
  link_image: linkImage,
  cta_label: ctaLabel,
  isOdd,
}: MResultContentItemProps) => {
  return (
    <div
      className={classNames('my-6 flex flex-col md:flex-row', {
        'md:flex-row-reverse': isOdd,
      })}
    >
      {linkImage.url && (
        <div className="relative w-full md:w-[50%] h-[113px] md:h-[240px]">
          <Image
            src={linkImage.url}
            alt={linkImage.alt ?? ''}
            fill
            style={{ objectFit: 'cover' }}
          />
        </div>
      )}
      <div className="flex flex-col w-full md:w-[50%] justify-center items-center p-6 bg-primary-dark-teal text-center text-neutral-white">
        {linkHeading && <h4 className="text-2xl mb-4">{linkHeading}</h4>}
        {linkSubHeading && <p className="mb-4">{linkSubHeading}</p>}
        {ctaLabel && linkUrl && (
          <a
            key={`${linkUrl.url}-${ctaLabel}`}
            href={linkUrl.url}
            className="block shadow-lg px-8 py-3 md:py-4 mt-4 font-semibold text-neutral-black uppercase duration-300 rounded-full md:text-sm md:py-1 md:mt-0 bg-neutral-white lg:hover:bg-primary-teal w-full md:max-w-[300px]"
          >
            {ctaLabel}
          </a>
        )}
      </div>
    </div>
  )
}
